import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_details';
export const route = 'alt_details/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_details" */
/* webpackPrefetch: true */
'../components/AltDetailsPage')));